'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startsWithVowel = function startsWithVowel() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.match('^[aieouAIEOU].*');
};

var NotAvailableComponent = function NotAvailableComponent(_ref) {
  var metricName = _ref.metricName,
      platform = _ref.platform,
      assetType = _ref.assetType;
  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'grey' }),
    content: 'The ' + _lodash2.default.capitalize(platform) + ' platform does not support ' + _lodash2.default.capitalize(metricName) + ' for ' + (startsWithVowel(assetType) ? 'an' : 'a') + ' ' + assetType + '.'
  });
};

exports.default = NotAvailableComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/not-available-component/index.js
// module id = 91
// module chunks = 1